import { isClienteAnaliseMercadoRevisaoStatusSemRevisao, isClienteAnaliseMercadoRevisaoStatusAberta, isClienteAnaliseMercadoRevisaoStatusAprovada } from '../domain';

/** Dados de uma revisão de Análises de Mercado na pesquisa de revisões */
export class ClienteAnaliseMercadoRevisaoSearch {
    id: number;
    idEmpresa: number;
    ano: number;
    // Representante
    idRepresentante: number;
    codigoIntegracaoErpRepresentante: string;
    cnpjCpfRepresentante: string;
    nomeRepresentante: string;
    nomeFantasiaRepresentante: string;
    // Revisão
    revisao: number;
    versao: number;
    status: number;
    private _isSemRevisao: boolean;
    // Abertura
    private _isAberta: boolean;
    dataAbertura: Date;
    idUsuarioAbertura: number;
    avatarURLUsuarioAbertura: string;
    nomeUsuarioAbertura: string;
    // Aprovação
    private _isAprovada: boolean;
    dataAprovacao: Date;
    idUsuarioAprovacao: number;
    avatarURLUsuarioAprovacao: string;
    nomeUsuarioAprovacao: string;
    justificativaAprovacao: string;

    constructor(props: Partial<ClienteAnaliseMercadoRevisaoSearch>) {
        Object.assign(this, props);
        this._isSemRevisao = isClienteAnaliseMercadoRevisaoStatusSemRevisao(this.status);
        // Abertura
        this._isAberta = isClienteAnaliseMercadoRevisaoStatusAberta(this.status);
        // Aprovação
        this._isAprovada = isClienteAnaliseMercadoRevisaoStatusAprovada(this.status);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objeto criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRevisaoSearch {
        return new ClienteAnaliseMercadoRevisaoSearch(JSON.parse(json));
    }

    /** Se se está sem revisão */
    get isSemRevisao(): boolean {
        return this._isSemRevisao;
    }

    /** Se a revisão está aberta */
    get isAberta(): boolean {
        return this._isAberta;
    }

    /** Se a revisão está aprovada */
    get isAprovada(): boolean {
        return this._isAprovada;
    }
}
